<template>
  <div class="sim">
    <ul>
      <label>検索結果：{{result_players.length}}件（最大{{resultmax}}件）</label>
      <table class="table table-striped table-hover resultlist">
        <thead class="thead-dark">
          <tr><th>スコア</th><th>名前</th>
          <th v-for="(value, key) in PrintRecordList" :key="key">{{RecordName(value)}}</th>
          <tr v-for="(value, key) in result_players" :key="key"><td>{{value['score']}}</td>
          <td><font color="#42b983"><a @click="setID (users[value['num']]['id'], users[value['num']]['nen']);"><u>{{users[value['num']]['r_name'] + (Yearcheck === 'y' ? '/' + users[value['num']].nen : '')}}</u></a></font></td>
          <td v-for="(rec, r_key) in PrintRecordList" :key="r_key">
            {{
              (rec === 'AVG' || rec === 'SLG' || rec === 'OBP' || rec === 'OPS' || rec === 'WR' ? printAVG(calcRecord(rec, users[value['num']]), 3) :
              rec === 'IPa' ? (users[value['num']][rec] + users[value['num']]['IPb'] / 10) :
              rec === 'ERA' ? printAVG(users[value['num']][rec], 2) :
              rec === 'FIP' ? printAVG(calcFIP(users[value['num']]), 2):
              rec === 'DEF' ? printDEF(users[value['num']][rec]):
              users[value['num']][rec])
            }}
          </td>
          </tr>
        </thead>
      </table>
    </ul>
  </div>
</template>

<script>
import Mixin from '../../mixins/utility'
export default {
  name: 'SeachResult',
  mixins: [Mixin]
}
</script>



// WEBPACK FOOTER //
// src/components/SimilarityParts/SeachResult.vue